import * as Yup from "yup";

export const initialProfileValues = {
  address: "",
  zipCode: "",
  city: "",
  state: "",
  country: "",
  propertyType: "",
  propertySize: "",
  ownershipType: "",
  totalBedrooms: "",
  totalBathrooms: "",
  // kitchenSize: "",
  // livingRoomSize: "",
  propertyPrice: "",
  propertyName: "",
  note: "",
};

export const initialPropertyValues = {
  propertyType: "",
  propertySize: "",
  ownershipType: "",
  totalBedrooms: "",
  totalBathrooms: "",
  // kitchenSize: "",
  // livingRoomSize: "",
  propertyPrice: "",
  propertyName: "",
  note: "",
};

export const ProfileSchema1 = Yup.object().shape({
  address: Yup.string().required("Address is a required field"),
  zipCode: Yup.string().required("Zip code is a required field"),
  city: Yup.string().required("City is a required field"),
  state: Yup.string().required("State is a required field"),
  country: Yup.string().required("Country is a required field"),
});
export const ProfileSchema2 = Yup.object().shape({
  // propertyType: Yup.string().required("Property Type is a required field"),
  propertyName: Yup.string().required("Property Name is a required field"),
  propertySize: Yup.string().required("Property Size is a required field"),
  // ownershipType: Yup.string().required("Ownership Type is a required field"),
  totalBedrooms: Yup.string().required("Total Bedroom is a required field"),
  totalBathrooms: Yup.string().required("Total Bathroom is a required field"),
  // kitchenSize: Yup.string().required("Kitchen Size is a required field"),
  // livingRoomSize: Yup.string().required("Living Room Size is a required field"),
  propertyPrice: Yup.string().required("Property Price is a required field"),
});

export const ProfileSchema3 = Yup.object().shape({
  note: Yup.string().required("Property Note is a required field"),
});

export const ProfileSchema = Yup.object().shape(
  {
    ...ProfileSchema1.fields,
    email: Yup.string().email("Invalid email format").trim().required("Email is a required field"),
    firstName: Yup.string().required("First name is a required field"),
    lastName: Yup.string().required("Last name is a required field"),
    phoneNumber: Yup.number().typeError("Only digit(s) is allowed").required("Phone number is a required field"),
    password: Yup.string().when("password", (val, _) => {
      if (val) {
        if (val.length > 0) {
          return Yup.string()
            .required("Password is required")
            .min(8, "minimum of 8 characters")
            // .matches(/[@$%#]+/, "Must contain at least one of @, $, #, %");
        } else {
          return Yup.string().notRequired();
        }
      } else {
        return Yup.string().notRequired();
      }
    }),
  },
  [["password", "password"]]
);
